import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../services/users/users.service';
import { SeoService } from '../../../services/seo/seo.service';
import { WindowrefService } from '../../../services/windowref/windowref.service';
import { FirestoreService } from 'src/app/services/firestore/firestore.service';
import { firstValueFrom } from 'rxjs';
import { FooterComponent } from '../../../components/footer/footer.component';
import { LoginComponent } from '../../../components/login/login.component';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { NucamptopnavComponent } from '../../../components/nucamptopnav/nucamptopnav.component';
import { IonicModule } from '@ionic/angular';

/**
 * Generated class for the WorkshopsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/*@IonicPage({
  name: 'AdmindecryptPage', 
  segment: 'admin/decrypt',
  priority: 'off'
})*/
@Component({
    styleUrls: ['./decrypt.page.scss'],
    selector: 'page-admindecrypt',
    templateUrl: 'decrypt.page.html',
    standalone: true,
    imports: [
        IonicModule,
        NucamptopnavComponent,
        NgIf,
        FormsModule,
        LoginComponent,
        FooterComponent,
    ],
})
export class AdmindecryptPage implements OnInit {
  pagename = 'AdmindecryptPage';
  scrolled: boolean;
  hasAccess = false;
  isAdmin = false;
  fetchingEncrypted = false;
  fetchingDecrypted = false;
  subsArr = [];
  rawData;
  encryptedData;
  decryptResult;

  constructor(
    private userProvider: UsersService,
    public windowRef: WindowrefService,
    private db: FirestoreService,
    private seo: SeoService
  ) {
  }

  logScrolling($event) {
    if ($event.detail.scrollTop > 1) {
      this.scrolled = true
    } else {
      this.scrolled = false
    }
  }

  async ngOnInit() {
    this.seo.generateTags(
      {
        title: 'Admin - Decryption Service',
        description: "Decryption Service",
        slug: 'admin/decrypt'
      }, null);

    this.subsArr.push(this.userProvider.checkrole(['admin', 'decryptor']).subscribe(value => this.hasAccess = value));
    this.subsArr.push(this.userProvider.checkrole(['admin']).subscribe(value => this.isAdmin = value));
  }

  ionViewWillLeave() {
    this.subsArr.forEach(sub => sub.unsubscribe());
  }

  encrypt(rawdata) {
    this.fetchingEncrypted = true;
    return firstValueFrom(this.db.post('/crypto/encode', {data: rawdata}))
        .then((result:any) => {
          // console.log("result encrypt", result);
          this.encryptedData = result.data;
          this.fetchingEncrypted = false;
        })
        .catch(err => {
          // console.log("err encrypt", err);
          this.fetchingEncrypted = false;
        })
  }

  decrypt(encrypteddata) {
    this.fetchingDecrypted = true;
    return firstValueFrom(this.db.post('/crypto/decode', {data: encrypteddata}))
        .then((result:any) => {
          // console.log("result decrypt", result);
          this.decryptResult = result;
          this.fetchingDecrypted = false;
        })
        .catch(err => {
          // console.log("err decrypt", err);
          this.decryptResult = err;
          this.fetchingDecrypted = false;
        })
  }
}
